import { CallDetail } from './call-detail';

interface CallDetailDrawerProps {
  callId: string;
  onClose: () => void;
}

export function CallDetailDrawer({ callId, onClose }: CallDetailDrawerProps) {
  return (
    <div className="fixed inset-0 z-50 flex">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Drawer panel */}
      <div className="relative ml-auto w-[768px] max-w-full h-full bg-gray-50 shadow-xl flex flex-col animate-in slide-in-from-right duration-300">
        {/* Close button */}
        <div className="flex items-center justify-end px-4 pt-4">
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto px-6 pb-6">
          <CallDetail callId={callId} />
        </div>
      </div>
    </div>
  );
}
